
import przelewy24_raty from 'assets/img/przelewy24_raty.png'
import { ReactComponent as GPay } from 'assets/GPay.svg'
import przelewy24 from 'assets/img/przelewy24.png'
import autopay from 'assets/autopay.svg'
import blik from 'assets/blik.png'

export const getPaymentIcon = (payment) => {
  switch (true) {
    case payment.key === 'gpay':
      return <GPay />

    case payment.key === 'blik':
      return <img
        alt='blik'
        src={blik}
      />

    case payment.key === 'credit':
      return <img
        alt='raty'
        src={przelewy24_raty}
      />

    case (payment.key === 'online' && payment.paymentOperator === 'AUTOPAY'):
      return <img
        alt='autopay'
        src={autopay}
      />

    case (payment.key === 'online' && payment.paymentOperator === 'PRZELEWY24'):
      return <img
        alt='przelewy24'
        src={przelewy24}
      />

    default: return undefined
  }
}